import React, { useMemo } from 'react';
import { sanitizeI3Html } from '../cms/sanitizeI3Html';

type Props = {
  html: string;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
};

/**
 * Renders trusted-sanitized HTML from CMS (featured description, past events, etc.).
 */
const I3RichHtml: React.FC<Props> = ({ html, className, as: Tag = 'div' }) => {
  const clean = useMemo(() => sanitizeI3Html(html), [html]);
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
};

export default I3RichHtml;
